module.exports = __webpack_public_path__ + "static/media/21.c44c8f39.jpg";